import React from 'react'

const Modal = (props) => {
  return (
    <div>
        {(props.isOpen) ? 
          <div className='modal-overlay'>
            <div className={'modal-container '+props.className}>
              {props.children}
            </div>
          </div> : null
        }
    </div>
  )
}

export default Modal;